import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const redirectUri = handleActions(
  {
    [combineActions(
      actionTypes.UPLOAD_FILE_REQUEST,
      actionTypes.UPLOAD_FILE_FAILURE,
      actionTypes.CREATE_XML_REQUEST,
      actionTypes.CREATE_XML_FAILURE,
      actionTypes.UPLOAD_ACTION_REQUEST,
      actionTypes.UPLOAD_ACTION_FAILURE,
    )]: () => '',
    [combineActions(
      actionTypes.UPLOAD_FILE_SUCCESS,
      actionTypes.CREATE_XML_SUCCESS,
      actionTypes.UPLOAD_ACTION_SUCCESS,
    )]: (state, { payload }) => payload.redirectUri,
  },
  '',
);

export const id = handleActions(
  {
    [combineActions(
      actionTypes.UPLOAD_FILE_REQUEST,
      actionTypes.UPLOAD_FILE_FAILURE,
      actionTypes.CREATE_XML_REQUEST,
      actionTypes.CREATE_XML_FAILURE,
    )]: () => '',
    [combineActions(
      actionTypes.UPLOAD_FILE_SUCCESS,
      actionTypes.CREATE_XML_SUCCESS,
    )]: (state, { payload }) => payload.id,
  },
  '',
);

export const isLoading = handleActions(
  {
    [actionTypes.UPLOAD_FILE_REQUEST]: () => true,
    [combineActions(actionTypes.UPLOAD_FILE_SUCCESS, actionTypes.UPLOAD_FILE_FAILURE)]: () => false,
  },
  false,
);

export const isCreating = handleActions(
  {
    [actionTypes.CREATE_XML_REQUEST]: () => true,
    [combineActions(actionTypes.CREATE_XML_SUCCESS, actionTypes.CREATE_XML_FAILURE)]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      actionTypes.UPLOAD_FILE_REQUEST,
      actionTypes.UPLOAD_FILE_SUCCESS,
      actionTypes.UPLOAD_ACTION_REQUEST,
      actionTypes.UPLOAD_ACTION_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.UPLOAD_FILE_FAILURE,
      actionTypes.UPLOAD_ACTION_FAILURE,
    )]: (state, { payload }) => payload.error || {},
  },
  {},
);

export const createXMLFailed = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_XML_REQUEST,
      actionTypes.CREATE_XML_SUCCESS,
      actionTypes.UPLOAD_FILE_REQUEST,
    )]: () => false,
    [actionTypes.CREATE_XML_FAILURE]: () => true,
  },
  false,
);

export const createXMLSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CREATE_XML_REQUEST,
      actionTypes.CREATE_XML_FAILURE,
    )]: () => false,
    [actionTypes.CREATE_XML_SUCCESS]: () => true,
  },
  false,
);

export const needsMoreData = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPLOAD_FILE_REQUEST,
      actionTypes.CREATE_XML_REQUEST,
      actionTypes.CREATE_XML_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.CREATE_XML_SUCCESS,
      actionTypes.UPLOAD_FILE_SUCCESS,
    )]: (state, { payload }) =>
        payload.headerInput || payload.draftInputs,
  },
  false,
);

export const requestedData = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPLOAD_FILE_REQUEST,
      actionTypes.CREATE_XML_REQUEST,
      actionTypes.CREATE_XML_FAILURE,
    )]: () => ({}),
    [combineActions(
      actionTypes.CREATE_XML_SUCCESS,
      actionTypes.UPLOAD_FILE_SUCCESS,
    )]: (state, { payload }) => payload,
  },
  {},
);

export const selectedEquipment = handleActions(
  {
    [actionTypes.SET_SELECTED_EQUIPMENT]: (state, { payload }) => payload,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPLOAD_FILE_FAILURE,
    )]: () => -1,
  },
  -1,
);

export default combineReducers({
  id,
  redirectUri,
  isLoading,
  isCreating,
  error,
  createXMLFailed,
  selectedEquipment,
  createXMLSuccess,
  needsMoreData,
  requestedData,
});
